// -- React and related libs
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Redirect,
  useLocation,
  useNavigate,
  Link,
} from "react-router-dom";

import Header from "../components/Header/Header";
//import HomePage from "../../pages/HomePage";
import Sidebar from "../components/Sidebar/Sidebar";
import Tables from "../components/Tables/Tables";
import Footer from "../components/Footer/Footer";
import ListRecargasTables from "../components/Tables/RecargasList";
//import Breadcrumbs from "../Breadbrumbs/Breadcrumbs";
import { useDispatch, useSelector } from "react-redux";

// -- Component Styles
import s from "../components/Layout/Layout.module.scss";

const ReservasDiaPage = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;
  //console.log(location);
  useEffect(() => {
    if (!userInfo) {
      navigate("/login");
    }
  }, [userInfo, navigate]);

  return (
    <div className={s.root}>
      <div className={s.wrap}>
        <Header />
        <Sidebar />
        <main className={s.content}>
          <ListRecargasTables />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default ReservasDiaPage;
